<!-- 个人信息 -->
<template>
	<div class="bindnew">
        <van-form >
        <van-field
            v-model="phone"
            label="新手机号码"
            placeholder="请输入新的手机号"
            :border="false"
        >
            <div slot="label" class="phone-label" @click="showPicker = true">
                <img :src="flag_src" alt="" />
                <span>{{ "+" + area_code }}</span>
                <van-icon name="arrow-down" />
            </div>
        </van-field>
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <van-field
            v-model="img_code"
            label="图形验证"
            placeholder="请输入图形验证码"
            :border="false"
            use-button-slot
        >
            <img
                slot="button"
                class="img-code"
                :src="image_code"
                @click="changeImgCode"
            />
        </van-field>
        <van-field
            v-model="sms"
            label="短信验证"
            placeholder="请输入验证码"
             :border="false"
            use-button-slot
        >
        <van-button slot="button"  size="small" type="primary"
                        @click="sendCode" plain color="#d2020d">{{sendTimeText}}</van-button>
        </van-field>
    <div style="margin: 30px;">
        <van-button round block type="info" native-type="submit" color="#d2020d" @click="onSubmit">提交</van-button>
    </div>
</van-form>
		
	</div>
</template>
<script>
	import {SendCode,BindMobile,PersoanalUserInfo,imgCode,countryPhoneCode} from '../../../config/interface.js'
    let codeTimer;
	export default{
		data(){
			return{
				userInfo:'',
                showKeyboard:false,
                phone:'',
                sms:'',
                img_code:'',
                image_code:'',
                isClick: true,
                sendTimeText:'获取验证码',
                countdown:60,
				isReSend:true,     //能否再次点击发送验证码
                showPicker: false,
                area_code: '86',
                flag_src: require('../../../assets/images/System/flag/China.png'),
                columns: [
                    '中国',
                    '中国香港',
                    '中国澳门',
                    '中国台湾',
                    '新加坡',
                    '英国',
                    '美国',
                    '加拿大',
                    '希腊',
                    '荷兰',
                    '比利时',
                    '法国',
                    '西班牙',
                    '爱尔兰',
                    '瑞士',
                    '德国'
                ],
                codes: {},
                flags: {
                    '中国': require('../../../assets/images/System/flag/China.png'),
                    '中国香港': require('../../../assets/images/System/flag/China.png'),
                    '中国澳门': require('../../../assets/images/System/flag/China.png'),
                    '中国台湾': require('../../../assets/images/System/flag/China.png'),
                    '新加坡': require('../../../assets/images/System/flag/Singapore.png'),
                    '英国': require('../../../assets/images/System/flag/UK.png'),
                    '美国': require('../../../assets/images/System/flag/USA.png'),
                    '加拿大': require('../../../assets/images/System/flag/Canada.png'),
                    '希腊': require('../../../assets/images/System/flag/Greece.png'),
                    '荷兰': require('../../../assets/images/System/flag/Holland.png'),
                    '比利时': require('../../../assets/images/System/flag/Belgium.png'),
                    '法国': require('../../../assets/images/System/flag/France.png'),
                    '西班牙': require('../../../assets/images/System/flag/Spain.png'),
                    '爱尔兰': require('../../../assets/images/System/flag/Ireland.png'),
                    '瑞士': require('../../../assets/images/System/flag/Swit.png'),
                    '德国': require('../../../assets/images/System/flag/Germany.png'),
                }
			}
		},
        created()
        {
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){
			this.getImgCode();
            this.getCountryCode();
		},
		methods:{
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
            //区号
            getCountryCode(){
                const url=countryPhoneCode;
                const method='POST';
                fetch(url,{},method).then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        data.forEach(element=>{
                            this.codes[element.country_cn]=element.code;
                        });
                    }
                })
            },
            //区号选择
            onConfirm(value){
                this.area_code=this.codes[value];
                this.flag_src=this.flags[value];
                this.showPicker=false;
            },
            // 获取图形验证码
            getImgCode(){
                const url=imgCode;
                const method='GET';
                fetch(url,{},method)
                .then((res)=>{
                    if(res.code==0){
                        this.image_code=res.data.base64_image;
                    }
                })
            },
            // 点击刷新图形验证码
            changeImgCode(){
                this.getImgCode();
            },
            // 发送验证码
			getCode(){
                this.sendTime();
				const url=SendCode;
				let params={
                    mobile:this.phone,
                    country_code:this.area_code,
                    code:this.img_code,
                };
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						common.toast(res.data.code,1000,'success',()=>{
						})
					}
                    else{
                        this.isReSend=true;
                        this.clearCodeTimer();
                        this.getImgCode();
                        common.toast(res && res.error_msg?res.error_msg: "未知错误",1000,'fail',()=>{
										})

                    }
				})
			},
            //点击发送验证码
			sendCode(){
				if(this.isReSend&&this.verifyMobile()){
					this.getCode();
					this.isReSend=false;
				}
			},
            //验证手机号
			verifyMobile(){
				let mobile=this.phone;
				if(mobile==''){
					common.toast('请输入手机号',1000)
				}else if(!(/^1[3456789]\d{9}$/.test(mobile)) && this.area_code=='86'){
					common.toast('请输入正确手机号',1000)
				}else if(this.img_code==''){
					common.toast('请输入图形验证码',1000)
				}else{
					return true;
				}
				return false;
			},
            sendTime(){
					codeTimer=setTimeout(()=>{
						if(this.countdown==1){
							this.clearCodeTimer();
							return;							
						}else{
							this.countdown--;
							this.sendTimeText='重新发送('+this.countdown+'s)';
							setTimeout(this.sendTime(), 1000);
						}
				  	}, 1000)
			},
			//清除定时器
			clearCodeTimer(){
				clearTimeout(codeTimer);
				this.isReSend=true;
				this.sendTimeText="获取验证码";
				this.countdown=60;
			},
            onSubmit(){
                if(!this.verifyMobile()){
                    return;
                }
                if(this.sms==''){
                    common.toast('请输入短信验证码',1000);
                    return;
                }
                const url=BindMobile;
				let params={
                    mobile: this.phone,
                    msgcode: this.sms,
                    code: this.img_code,
                    country_code: this.area_code,
                };
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						common.toast('修改成功',1000,'success',()=>{
                            this.$router.push({
                                path:'/vascularNews/personal'
                            })
						})
					}
                    else{
                        this.getImgCode();
                        common.toast(res && res.error_msg?res.error_msg: "未知错误",1000,'fail',()=>{
										})
                    }
				})

            }
		},
        destroyed(){
            this.clearCodeTimer();
        }
	}
</script>
<style lang="scss">
.bindnew {
    .phone-label {
        display: flex;
        align-items: center;
        gap: 4px;
        min-width: 90px;

        img {
            height: 16px;
            vertical-align: middle;
        }

        span {
            font-size: 14px;
            color: #323233;
        }
    }

    .img-code {
        height: 28px;
        vertical-align: middle;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/User/BindNew.vue